import type { RetargetingDisposition } from '@openx/types/targeting/retargeting.ts';
import type { TFunction } from 'i18next';

export const getRetargetingListPresentation = (disposition: RetargetingDisposition | '', t: TFunction) => {
  const isInclude = disposition === 'target';

  return {
    isInclude,
    sectionTitle: isInclude ? t('Retarget') : t('Suppress'),
    listTitle: isInclude ? t('Included') : t('Excluded'),
  };
};
